import React, { useEffect, useState } from "react";
import { getCustomStories } from "../../../api/customAPI";
import NikkiWrapper from "../wrapper/NikkiWrapper";
import "../../../styles/components/selectbook/SelectSteps.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function SelectStory({
  onNext,
  setStoryId,
  onAlert,
  onSelectSound,
  onNextSound,
  setStoryList,
}) {
  const { t } = useAppTranslation("components/selectbook/selectStory");
  const [stories, setStories] = useState([]);
  const [selectedStoryId, setSelectedStoryId] = useState(null);

  useEffect(() => {
    const response = getCustomStories({ plan_id: "" });
    response.then((res) => {
      if (res.success) {
        setStories(res.data);
        setStoryList?.(res.data);
      } else {
        console.log(res.error.errMsg);
      }
    });
  }, [setStoryList]);

  const handleNext = () => {
    if (!selectedStoryId) {
      onAlert(t("alerts.selectStory"));
      return;
    }
    onNextSound?.();
    setStoryId(selectedStoryId);
    onNext();
  };

  return (
    <NikkiWrapper
      titleDescription={t("titleDescription")}
      progressValue="10"
      onNext={handleNext}
      onNextSound={onNextSound}
    >
      <h3>{t("title")}</h3>
      <div className="divider" />
      <ul className="story-list">
        {stories.map((story) => (
          <li
            key={story.plan_id}
            className={selectedStoryId === story.story_id ? "action" : ""}
            onClick={() => {
              onSelectSound?.();
              setSelectedStoryId((prev) =>
                prev === story.story_id ? null : story.story_id,
              );
            }}
          >
            <figure>
              <img
                src={story.plan_cover}
                alt={t("alts.storyCover", { title: story.plan_title })}
              />
            </figure>
            <p>{story.plan_title}</p>
          </li>
        ))}
      </ul>
      {stories.length > 4 && (
        <div className="scroll-indicator">
          <img
            src="/images/makingBranch/arrow-down.svg"
            alt={t("alts.scrollDown")}
          />
          <span>{t("scroll")}</span>
        </div>
      )}
    </NikkiWrapper>
  );
}
